<template>
  <div>
    <div class="content">
      <div class="header-table">
        <table>
          <tbody>
            <tr>
              <td class="header-in-table">안전·보건 순회점검 자율점검표</td>
              <td rowspan="2" class="th-background" style="width: 40px">결<br /><br />재</td>
              <td class="th-background" style="width: 120px">작성자</td>
              <td class="th-background" style="width: 120px">검토자</td>
              <td class="th-background" style="width: 120px">회람자</td>
              <td class="th-background" style="width: 120px">승인자</td>
            </tr>
            <tr>
              <td class="content-title" valign="bottom"><i class="dot"></i> 학교(기관) 현황</td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign1 !== 'undefined' ? `url(${form.sign1.sign})` : '' }"></td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign2 !== 'undefined' ? `url(${form.sign2.sign})` : '' }"></td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign3 !== 'undefined' ? `url(${form.sign3.sign})` : '' }"></td>
              <td class="signCell" :style="{ backgroundImage: typeof form.sign4 !== 'undefined' ? `url(${form.sign4.sign})` : '' }"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content-table">
        <table>
          <tbody>
          <tr>
            <th>학교(기관명)</th>
            <td colspan="2">{{ form.stdInfo.field_name }}</td>
            <th>점검일</th>
            <td colspan="2">{{ form.stdInfo.점검일 }}</td>
          </tr>
          <tr>
            <th rowspan="2">현업근로자 수</th>
            <th>조리</th>
            <th>시설관리</th>
            <th>청소</th>
            <th>통학차량보조</th>
            <th>기타</th>
          </tr>
          <tr>
            <td>{{ form.inputA_1 }}</td>
            <td>{{ form.inputA_2 }}</td>
            <td>{{ form.inputA_3 }}</td>
            <td>{{ form.inputA_4 }}</td>
            <td>{{ form.inputA_5 }}</td>
          </tr>
          <tr>
            <th>도급종사자</th>
            <td>{{ form.inputB_1 }}</td>
            <td>{{ form.inputB_2 }}</td>
            <td>{{ form.inputB_3 }}</td>
            <td>{{ form.inputB_4 }}</td>
            <td>{{ form.inputB_5 }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="content-table">
        <div class="content-title"><i class="dot"></i> 점검표</div>
        <table-inspect-merge
          :is-print="true"
          :is-readonly="board.readonly"
          :table-header-title="'점검사항'"
          :table-header-check="[{ text: '적정' }, { text: '미흡' }, { text: '해당없음' }]"
          :tableHeaderNote="[{ text: '점검결과(미흡 시 사유 기재)', width: '180px' }, {text: '증빙자료', width: '180px'}]"
          contentBefore="•"
          v-model="form.inspectList"
          :only-pc="true"
          class="mt-5"
        >
          <template #customType="{ trData, id, input, noteIndex }">
            <div v-if="trData">
              <div
                v-if="trData.customTypes.length <= noteIndex ?
      (trData.customTypes[0] !== 4 && trData.customTypes[0] !== 5)
      : (trData.customTypes[noteIndex] !== 4 && trData.customTypes[noteIndex] !== 5)"
                class="p-2">
                <div v-for="(field, index) in fieldsByType(trData.customTypes.length <= noteIndex ? trData.customTypes[0] : trData.customTypes[noteIndex])"
                     :key="index" class="flex justify-between items-center mt-1">
                  <span>{{ field.label }}</span>
                  <p class="print-input flex-1 ml-1">{{ trData[field.inputKey] }}</p>
                </div>
              </div>
              <div v-else class="p-2">
                <div class="flex justify-between items-center mt-1">
                  <p class="print-input flex-1 ml-1">{{ trData.input1_1 }}</p>
                </div>
              </div>
            </div>
          </template>
        </table-inspect-merge>
      </div>

      <div class="content-table">
        <div class="content-title"><i class="dot"></i> 사진대지</div>
        <photo-upload-grid-module
          :printRowCount="1"
          v-model="form.photoList"
          :is-print="true"
          :readonly="board.readonly"
          placeholder="신축현장 점검"
        />
      </div>
    </div>

  </div>
</template>

<script>
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import FileUploader from "@/components/FileUploader.vue";
export default {
  name: "Print670",
  components: {FileUploader, TableCustom, DateSelector, TableInspectMerge},
  props: {
    form: Object,
    board: Object,
  },
  computed: {
    getTitles() {
      if (!this.form.inspectList) {
        return [];
      }
      return this.form.inspectList.map((item) => item.title);
    },
  },
  methods: {
    getCheckBoxUrl(checked) {
      if (checked) {
        return `@/assets/images/print/print_check_checked.svg`;
      } else {
        return `@/assets/images/print/print_check_unchecked.svg`;
      }
    },
    fieldsByType(type) {
      switch (type) {
        case 1:
        case 3:
          return [
            { label: '실시일', inputKey: 'input1', inputComponent: 'date-selector', style: { minWidth: '200px' } },
            { label: '실시일', inputKey: 'input2', inputComponent: 'date-selector', style: { minWidth: '200px' } },
            ...(type === 3 ? [{ label: '개선사항', inputKey: 'input3', inputComponent: 'ml-input' }] : []),
            // Add more fields as needed
          ];
        case 2:
          return [
            { label: '교육대상', inputKey: 'input1', inputComponent: 'ml-input' },
            { label: '실시인원', inputKey: 'input2', inputComponent: 'ml-input' },
            // Add more fields as needed
          ];
        case 6:
          return [
            { label: '미실시 인원', inputKey: 'input1', inputComponent: 'ml-input' },
            { label: '실시인원', inputKey: 'input2', inputComponent: 'ml-input' },
            // Add more fields as needed
          ];
        case 7:
          return [
            { label: '실시일', inputKey: 'input1', inputComponent: 'date-selector', style: { minWidth: '200px' } },
            { label: '개선사항', inputKey: 'input2', inputComponent: 'ml-input' },
            { label: '조치사항', inputKey: 'input3', inputComponent: 'ml-input' },
            // Add more fields as needed
          ];
        default:
          return [];
      }
    }
  },
};
</script>

<style lang="scss" scoped>
$border-color: #cdcdcd;
.header {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
  padding: 20px 0;
}
.content {
  .content-title {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    margin-bottom: 14px;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 10px;
    }
  }
  .header-table {
    table {
      width: 100%;
      border-collapse: collapse;
      tr:nth-child(1) {
        text-align: center;
        td {
          padding: 10px;
        }
        td:nth-child(n + 2) {
          font-size: 18px;
          font-weight: 500;
          border-left: 1px solid #cdcdcd;
          border-top: 1px solid #cdcdcd;
          border-right: 1px solid #cdcdcd;
        }
      }
      tr:nth-child(2) {
        height: 100px;
        td:nth-child(1) {
          padding-bottom: 15px;
        }
        td:nth-child(n + 2) {
          border-left: 1px solid #cdcdcd;
          border-top: 1px solid #cdcdcd;
          border-right: 1px solid #cdcdcd;
        }
      }
    }
    .header-in-table {
      font-size: 32px;
      font-weight: 700;
      line-height: 24px;
    }
    .signCell {
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  .content-table {
    .sub-header,
    .item-label {
      padding: 14px;
      text-align: left;
      font-size: 18px;
    }
    .sub-header {
      font-weight: 700;
    }
    .row-title {
      font-weight: 500;
    }
    .row-title:before {
      content: "•";
      display: inline-block;
      width: 1em;
      margin-left: 1em;
    }
    table {
      width: 100%;
      table-layout: fixed;
      border-collapse: collapse;
      margin-bottom: 40px;

      th,
      td {
        border: 1px solid #cdcdcd;
        text-align: center;
        min-height: 55px;
        height: 55px;
        font-size: 18px;
      }
      th {
        background-color: #f9f9f9;
        font-weight: 500;
        padding: 0;
      }
      td {
        min-width: 50px;
        word-break: keep-all;
        img {
          display: inline-block;
        }
      }
      .check-container {
        padding: 10px 14px 0 14px;
        text-align: left;

        div {
          margin-bottom: 8px;
        }
        img {
          display: inline-block;
          margin-right: 8px;
        }
      }
      .text-left {
        text-align: left;
        padding: 10px 14px;
      }
    }

    /*서명 테이블*/
    .sign-table {
      th,
      td {
        font-size: 14px;
      }

      tr th:nth-child(1),
      tr td:nth-child(1),
      tr th:nth-child(8),
      tr td:nth-child(8) {
        width: 64px;
      }

      .signCell {
        white-space: nowrap;
        min-width: 90px;
        padding: 2px;
        height: 50px;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
      }

      .signSpace {
        width: 10px;
        border-top: none;
        border-bottom: none;
      }
    }
  }

  .th-background {
    background-color: #f9f9f9;
    white-space: nowrap;
  }

  .print-break-page {
    page-break-before: always;
  }
}

.photoWrap {
  .photoContainer {
    display: flex;
    justify-content: center;
    width: 100%;
    border-radius: 6px;
    border: dashed 1px $border-color;
    break-inside: avoid;
  }
}
.photoWrap:nth-child(2n) {
}
.titleFull {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  width: 100%;
  height: 110px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
.table-inspect-merge-print {
  h5 {
    font-size: 24px;
    font-weight: 700;
    line-height: 35px;
    color: #3c3c3c;

    display: flex;
    align-items: center;

    .dot {
      width: 20px;
      height: 20px;
      background-color: transparent;
      border: 1px solid #3c3c3c;
      border-radius: 0;
      display: inline-block;
      margin-top: 3px;
      margin-right: 14px;
    }
  }

  .print-textarea,
  .print-input {
    border: none;
    border-radius: 0;
  }

  table {
    th,
    td {
      border: 1px solid #757575 !important;
      min-height: 55px !important;
      height: 55px !important;
      font-size: 18px !important;
      text-align: center !important;
    }
    th {
      background-color: #ececec !important;
      font-weight: 500 !important;
      padding: 0 !important;
    }

    .title-tr > td {
      background-color: #ececec !important;
      text-align: left !important;
    }

    .content[colspan='4'],
    .content[colspan='7']{
      padding: 0 !important;

      & > div {
        display: grid !important;
        grid-template-columns: auto 1fr;
        gap: 0 !important;
      }
      p {
        flex: none ;
        padding: 0.7rem !important;
        width: 140px !important;
        height: 100% !important;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      span {
        margin: 0 !important;
        border-left: 1px solid #757575 !important;
        white-space: pre-wrap;

        display: grid;
        align-items: center;
      }
    }
  }
}
</style>
